import { useEffect, useState, useRef } from "react";
import { collection, doc, getDoc, getDocs, orderBy, query, setDoc, where } from "firebase/firestore";
import { app, db } from "../Admin/Config/Config";
import { useLocation } from "react-router-dom";
import { useUser } from "../Auth/UsersContext";
import './assets/Scroll.css'
import { FaStar } from "react-icons/fa";
import './Pdfview'
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import ReactPlayer from "react-player";
import { getFunctions, httpsCallable } from "firebase/functions";
import Toast from "../Toast/Toast";
import LoadingTwo from "../Loading/LoadingTwo";
import { usePaymentSuccess } from "../Payment/PaymentStatusContext";
const VideoPage = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [purchaseLoading, setPurchaseLoading] = useState(false);
  const courseId = searchParams.get("id");
  const courseFolder = searchParams.get("fId");
  const { user } = useUser();
  const [play, setPlay] = useState(false);
  const [classList, setClassList] = useState([]);
  const [reviewCount, setReviewCount] = useState(0);
  const playerRef = useRef(null);
  const videoPlayerRef = useRef(null);
  const [videoPlayerUrl, setVideoPlayerUrl] = useState("");
  const [toastDetails, setToastDetails] = useState(null);
  const [showTopics, setShowTopics] = useState(false);
  const [topics, setTopics] = useState([]);
  const { openPaymentSuccess } = usePaymentSuccess();



  const navigate = useNavigate();
  // ================== Fetch Classes ================== //
  const handlefetchClass = async (q) => {
    const data = [];
    const classes = await getDocs(q);
    classes.forEach((doc) => {
      data.push({ id: doc.id, ...doc.data() });
    });
    if (data.length > 0) {
      setClassList(data);
      setMainClass(data[0]);
      setVideoPlayerUrl(
        data ? data[0].video_type === "youtube" ? data[0].youtube_url : data[0].video_url : null
      );
    }
  }
  useEffect(() => {
    const q1 = query(collection(db, "jaffers_english_study_content"),
      where("course_id", "==", courseId), where("status", "==", true),
      orderBy("order", "asc"));
    const q2 = query(collection(db, "jaffers_english_study_content"),
      where("course_id", "==", courseId), where("status", "==", true),
      where("folder_id", "==", courseFolder),
      orderBy("order", "asc"));
    handlefetchClass(courseFolder === "false" ? q1 : q2);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ================== Main class content ================== //
  const [mainClass, setMainClass] = useState({});
  const [mainClassIndex, setMainClassIndex] = useState(0);

  const [selectedTab, setSelectedTab] = useState('all');
  const [newReview, setNewReview] = useState('');
  const [reviews, setReviews] = useState([]);

  // ================== Fetch Reviews ================== //
  useEffect(() => {

    fetchReviews();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const fetchReviews = async () => {
    const reviewsRef = collection(db, "jaffers_english_reviews");
    const q = query(
      reviewsRef,
      where("course_id", "==", courseId),
      where("status", "==", true)
    );
    const reviewsSnap = await getDocs(q);
    setReviewCount(reviewsSnap.docs.length);
    const data = [];
    reviewsSnap.forEach((doc) => {
      data.push({ id: doc.id, ...doc.data() });
    });
    setReviews(data);
  };
  // ================== Handle Review Submit ================== //
  const handleReviewSubmit = async (e) => {
    e.preventDefault();
    if (newReview.trim() === '') {
      setToastDetails({
        type: "error",
        message: "Write a review to submit",
      });
      return;
    }
    if (rating === 0) {
      setToastDetails({
        type: "error",
        message: "Rate the course to submit review",
      });
      return;
    }
    await setDoc(doc(db, "jaffers_english_reviews", user.uid + courseId), {
      course_id: courseId,
      date: new Date(),
      name: user.name,
      rating: rating,
      review: newReview,
      uid: user.uid,
      status: true,
    });
    setNewReview('');
    setRating(0);
    fetchReviews();
    setToastDetails({
      type: "success",
      message: "Review submitted successfully",
    });
  };

  // ============== Handle Sort ============== //
  const handleSort = (e) => {
    const q1 = query(collection(db, "jaffers_english_study_content"),
      where("course_id", "==", courseId), where("status", "==", true),
      orderBy("order", e.target.value));
    const q2 = query(collection(db, "jaffers_english_study_content"),
      where("course_id", "==", courseId), where("status", "==", true),
      where("folder_id", "==", courseFolder),
      orderBy("order", e.target.value));
    handlefetchClass(courseFolder === "false" ? q1 : q2);
  }


  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);

  const handlePdfView = (mainClass) => {
    if (mainClass.pdf_url && mainClass.pdf_url !== "") {
      navigate("/pdf", { state: { url: mainClass.pdf_url } });
    } else {
      setToastDetails({
        type: "error",
        message: "No notes available",
      });
    }
  }
  // ================== Pre check ================== //
  const preCheck = (video, index) => {
    if (user?.je_courses?.includes(courseId) || video.is_lock === false) {
      setMainClass(video);
      setVideoPlayerUrl(
        video.video_type === "youtube"
          ? video.youtube_url
          : video.video_url
      );
      setMainClassIndex(index);
      // Scroll to video player on small screens
      if (window.innerWidth < 1024) {
        videoPlayerRef.current?.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      hanldePurchase();
    }
  }
  // ================== Pre play check ================== //

  const preplayCheck = () => {
    if (user?.je_courses?.includes(courseId) || !mainClass.is_lock) {
      setPlay(true);
    } else {
      hanldePurchase();
    }
  }
  const hanldePurchase = async () => {
    setPurchaseLoading(true);
    const docSnap = await getDoc(doc(db, "jaffers_english_courses", courseId));
    const functions = getFunctions(app, "asia-south1");

    if (docSnap.exists) {
      const data = docSnap.data();
      const payload = {
        study_stream: "Jaffers English",
        amount: parseFloat(data.offer_fee) * 100,
        email: user?.email ?? "",
        name: user?.name ?? "",
        mobile: user?.mobile ?? "",
        uid: user?.uid ?? "",
        course_id: data.id,
        title: data.title,
        district: user?.district ?? "",
        days: data.access_days,
        purchase_type: "course",
        platform: "web",
      };
      const paymentRequest = httpsCallable(functions, "createOrderId");
      paymentRequest({
        img: data.img_url,
        orderdetails: payload,
        amount: parseFloat(data.offer_fee) * 100,
      }).then((result) => {
        const order = result.data;
        if (order && order !== 404) {
          const options = {
            key: process.env.REACT_APP_RAZOR_KEY,
            amount: order.amount,
            currency: order.currency,
            name: "Jaffer's English",
            description: "Jaffer's English Course",
            image: data.img_url,
            order_id: order.id,
            method: {
              netbanking: true,
              card: true,
              upi: false, // 👈 this disables UPI in the Checkout form
              wallet: true,
            },
            handler: function (response) {
              openPaymentSuccess({
                status: "success",
                orderId: order.id,
                paymentId: response.razorpay_payment_id,
                courseTitle: data.title,
                amount: order.amount / 100,
              });
            },
            prefill: {
              name: order.notes.user_name,
              email: user.email,
              contact: user.mobile,
            },
            notes: {
              address: "Razorpay Corporate Office",
            },
            theme: {
              color: "#3399cc",
            },
            modal: {
              ondismiss: function () {
                // setloading(false);
              },
            },
          };

          try {
            const rzp1 = new window.Razorpay(options);
            rzp1.open();
            setPurchaseLoading(false);
            rzp1.on("payment.failed", function (response) {
              openPaymentSuccess({
                status: "failed",
                orderId: order.id || "",
                paymentId: response.razorpay_payment_id || "",
                courseTitle: data.title,
                amount: order.amount / 100,
                message: response.error.code,
              });
            });
          } catch (error) {
            setPurchaseLoading(false);
            openPaymentSuccess({
              status: "failed",
              orderId: order.id || "",
              courseTitle: data.title,
              amount: order.amount / 100,
            });
          }
        } else {
          setPurchaseLoading(false)
          setToastDetails({
            type: "error",
            message: "Payment Failed! Try again later.",
          });
        }
      });
    }

  }

  const handlePracticeClick = async () => {
    setTopics(mainClass.practice_url);
    if (user?.je_courses?.includes(courseId)) {
      setShowTopics(true);
    } else {
      hanldePurchase();
    }
  };

  return (
    <div className="bg-black min-h-screen p-2 sm:p-4">
      <LoadingTwo toggle={purchaseLoading} />
      <Toast
        type={toastDetails?.type}
        message={toastDetails?.message}
        onComplete={() => setToastDetails(null)}
      />
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 sm:gap-6">
        <div
          className="lg:col-span-2 space-y-4 sm:space-y-6"
          ref={videoPlayerRef}
        >
          <div className="relative bg-black border border-gray-900 rounded-lg overflow-hidden shadow-lg w-full aspect-video">
            {!play && mainClass ? (
              <div
                className="absolute inset-0 flex items-center justify-center cursor-pointer group"
                onClick={() => {
                  preplayCheck();
                }}
              >
                <img
                  src={mainClass.thumbnail}
                  alt="Custom Thumbnail"
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black/40 group-hover:bg-black/20 transition-all duration-300" />
                <button className="absolute rounded-full text-white transform transition-transform duration-300 group-hover:scale-110">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="66"
                    height="66"
                    fill="currentColor"
                    className="bi bi-play-circle"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                    <path d="M6.271 5.055a.5.5 0 0 1 .52.038l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 6 10.5v-5a.5.5 0 0 1 .271-.445" />
                  </svg>
                </button>
              </div>
            ) : (
              <div
                className="w-full aspect-video relative"
                onContextMenu={(e) => e.preventDefault()}
              >
                <ReactPlayer
                  className="absolute top-0 left-0 w-full h-full"
                  onContextMenu={(e) => e.preventDefault()}
                  tabIndex="0"
                  onKeyDown={(e) => {
                    if (e.code === "Space") {
                      e.preventDefault();
                      const player = playerRef.current;
                      if (player) {
                        player.getInternalPlayer().paused
                          ? player.getInternalPlayer().play()
                          : player.getInternalPlayer().pause();
                      }
                    }
                  }}
                  url={
                    videoPlayerUrl
                      ? mainClass?.video_type === "youtube"
                        ? "https://www.youtube.com/watch?v=" + videoPlayerUrl
                        : videoPlayerUrl
                      : ""
                  }
                  controls
                  width="100%"
                  height="100%"
                  playing={true}
                  config={{
                    youtube: {
                      playerVars: {
                        rel: 0,
                        modestbranding: 1,
                      },
                    },
                    file: {
                      attributes: {
                        controlsList: "nodownload",
                      },
                    },
                  }}
                />
              </div>
            )}
          </div>

          <div className="flex flex-wrap gap-3 sm:gap-4 p-3 sm:p-4 mt-4 sm:mt-5 bg-black backdrop-blur-sm rounded-xl border border-gray-800 justify-center sm:justify-start">
            {mainClass && mainClass?.practice_url?.length > 0 && (
              <button
                onClick={handlePracticeClick}
                className="flex-1 sm:flex-none flex items-center justify-center gap-2 text-white/90 px-4 sm:px-6 py-2.5 sm:py-3 rounded-lg 
              bg-gradient-to-r from-blue-600 to-blue-700 
              hover:from-blue-700 hover:to-blue-800
              transition-all duration-200
              hover:shadow-lg hover:-translate-y-0.5
              active:scale-95
              font-medium
              shadow-md shadow-blue-900/30
              border border-blue-400/20
              min-w-[140px]"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="w-5 h-5"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
                  />
                </svg>
                Practice
              </button>
            )}
            {mainClass && mainClass?.pdf_url && (
              <button
                onClick={() => {
                  if (
                    user?.je_courses?.includes(courseId) ||
                    !mainClass.is_lock
                  ) {
                    handlePdfView(mainClass);
                  } else {
                    hanldePurchase();
                  }
                }}
                className="flex-1 sm:flex-none flex items-center justify-center gap-2 text-white/90 px-4 sm:px-6 py-2.5 sm:py-3 rounded-lg 
              bg-gradient-to-r from-emerald-600 to-emerald-700 
              hover:from-emerald-700 hover:to-emerald-800
              transition-all duration-200
              hover:shadow-lg hover:-translate-y-0.5
              active:scale-95
              font-medium
              shadow-md shadow-emerald-900/30
              border border-emerald-400/20
              min-w-[140px]"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="w-5 h-5"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
                  />
                </svg>
                Note
              </button>
            )}
            {!user?.je_courses?.includes(courseId ?? []) &&
              mainClass.is_lock ? (
              <div className="absolute top-1/2 right-2 -translate-y-1/2 bg-gray-700/90 backdrop-blur-sm p-2 rounded-full flex items-center justify-center">
                <Lock size={16} color="white" />
              </div>
            ) : null}
          </div>

          <div className="mt-4 sm:mt-6 bg-black p-4 sm:p-6 rounded-lg border border-gray-800">
            <h1 className="text-xl sm:text-2xl font-bold text-gray-200">
              {mainClass?.title ?? "Loading..."}
            </h1>
            <p className="mt-2 text-gray-200 text-sm sm:text-base">
              {mainClass?.desc ?? "Loading..."}
            </p>
            {!user?.je_courses?.includes(courseId) && mainClass.is_lock && (
              <button
                onClick={hanldePurchase}
                className="mt-4 w-full sm:w-auto px-8 sm:px-12 py-2.5 sm:py-3 text-white font-semibold 
                bg-gradient-to-r from-emerald-600 to-emerald-700
                hover:from-emerald-700 hover:to-emerald-800
                transition-all duration-200
                rounded-lg shadow-md hover:shadow-lg active:scale-95"
              >
                Buy Now
              </button>
            )}
          </div>
        </div>

        <div className="lg:col-span-1">
          <div className="flex flex-col h-[calc(100vh-2rem)] sm:h-screen">
            <div className="bg-black border border-gray-900 p-3 sm:p-4 flex-grow overflow-y-auto rounded-lg no-scrollbar">
              <div className="flex justify-between items-center mb-3 sm:mb-4">
                <h2 className="text-base sm:text-lg font-medium text-emerald-700">
                  Video Classes
                </h2>

                <select
                  onChange={handleSort}
                  className="p-2 rounded bg-black text-gray-200 outline-none text-xs sm:text-sm border border-gray-800 focus:ring-0"
                >
                  <option value="">Sort options</option>
                  <option value="asc">ASC</option>
                  <option value="desc">DESC</option>
                </select>
              </div>

              <div className="flex space-x-4 border-b border-gray-800 pb-3 sm:pb-4">
                <button
                  onClick={() => setSelectedTab("all")}
                  className={`py-2 px-2 text-sm font-semibold ${selectedTab === "all"
                    ? "border-b-2 border-emerald-700 text-emerald-700"
                    : "text-gray-100 hover:text-gray-200"
                    }`}
                >
                  All Videos &nbsp;({classList?.length})
                </button>
                <button
                  onClick={() => setSelectedTab("reviews")}
                  className={`py-2 px-4 text-sm font-semibold ${selectedTab === "reviews"
                    ? "border-b-2 border-emerald-700 text-emerald-700"
                    : "text-gray-100 hover:text-gray-200"
                    }`}
                >
                  Reviews ({reviewCount})
                </button>
              </div>

              {selectedTab === "all" && (
                <div className="overflow-y-auto min-h-full py-3 sm:py-4 space-y-3">
                  {classList &&
                    classList.map((video, index) => (
                      <>
                        {video.style === "title" ? (
                          <div className="relative">
                            <div className="relative flex items-center space-x-4 bg-gray-950/90 backdrop-blur-xl p-4 rounded-xl px-5 py-2 border border-green-500/20 shadow-lg shadow-green-500/10">
                              <div className="relative">
                                <div className="w-1 h-6 bg-gradient-to-b from-green-400 via-emerald-500 to-emerald-700 rounded-full shadow-lg shadow-green-500/30"></div>
                              </div>

                              <div className="flex-1">
                                <p className="text-base font-semibold text-green-50 leading-relaxed">
                                  {video.title}
                                </p>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div
                            onClick={() => {
                              preCheck(video, index);
                            }}
                            key={index}
                            className={`relative flex items-center ${mainClassIndex === index
                              ? "bg-gray-950"
                              : "bg-gray-950"
                              } border border-gray-700 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 overflow-hidden p-2 cursor-pointer hover:bg-gray-900`}
                          >
                            {" "}
                            {video.thumbnail && (
                              <div className="relative w-24 sm:w-36 h-16 sm:h-20 flex-shrink-0">
                                <img
                                  src={video.thumbnail}
                                  alt={video.title}
                                  className="w-full h-full object-cover rounded-lg"
                                />

                                <div className="absolute bottom-1 right-1 bg-black bg-opacity-75 text-white text-xs px-1 py-0.5 rounded">
                                  {video.video_length} Min
                                </div>
                              </div>
                            )}
                            <div className="ml-3 flex-1 min-w-0">
                              <h3 className="text-sm font-semibold text-gray-100 line-clamp-2">
                                {video.title}
                              </h3>
                              <p className="text-xs text-gray-400 line-clamp-2">
                                {video.desc}
                              </p>
                            </div>
                            {!user?.je_courses?.includes(courseId ?? []) &&
                              video.is_lock && (
                                <div className="absolute top-1 right-2 bg-gray-700 bg-opacity-90 p-2 rounded-full flex items-center justify-center z-10">
                                  <Lock size={14} color="white" />
                                </div>
                              )}
                          </div>
                        )}
                      </>
                    ))}
                  <div className="space-y-3">
                    {mainClass && mainClass?.pdf_url && (
                      <>
                        <h2 className="text-emerald-700 text-base font-medium">
                          Notes
                        </h2>

                        <div
                          className="flex items-center justify-between bg-black border border-gray-800 p-3 rounded-lg shadow cursor-pointer"
                          onClick={() => {
                            handlePdfView(mainClass);
                          }}
                        >
                          <img
                            src="https://cdn-icons-png.flaticon.com/512/337/337946.png"
                            alt="PDF Icon"
                            className="h-8 w-8"
                          />

                          <div className="flex-1 ml-3 min-w-0">
                            <p className="text-white text-sm font-medium truncate">
                              Important Notes
                            </p>
                            <p className="text-gray-200 text-xs truncate">
                              Click here to view notes
                            </p>
                          </div>

                          <button className="text-gray-600 hover:text-gray-800 transition ml-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-5 w-5 sm:h-6 sm:w-6"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M9 5l7 7-7 7"
                              />
                            </svg>
                          </button>
                          {!user?.je_courses?.includes(courseId ?? []) &&
                            mainClass.is_lock && (
                              <div className="bg-gray-700 bg-opacity-90 p-2 rounded-full flex items-center justify-center ml-2">
                                <Lock size={16} color="white" />
                              </div>
                            )}
                        </div>
                      </>
                    )}

                    {mainClass && mainClass?.test_url && (
                      <>
                        <h2 className="text-emerald-700 text-base font-medium mt-4">
                          Exams
                        </h2>
                        <div className="flex items-center justify-between bg-black border-gray-800 border p-3 rounded-lg shadow">
                          <button
                            className="flex items-center gap-2 text-white/90 px-3 sm:px-4 py-2 rounded-lg 
                        bg-gradient-to-r from-emerald-600 to-emerald-700 
                        hover:from-emerald-700 hover:to-emerald-800
                        transition-all duration-200
                        hover:shadow-lg hover:-translate-y-0.5
                        active:scale-95
                        font-medium
                        shadow-md shadow-emerald-900/30
                        border border-emerald-400/20"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              strokeWidth="1.5"
                              stroke="currentColor"
                              className="w-4 h-4 sm:w-5 sm:h-5"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
                              />
                            </svg>
                          </button>
                          <div
                            onClick={() => {
                              window.open(mainClass?.test_url ?? "", "_blank");
                            }}
                            className="flex-1 ml-3 min-w-0 cursor-pointer"
                          >
                            <p className="text-white text-sm font-medium truncate">
                              Tests
                            </p>
                            <p className="text-gray-200 text-xs truncate">
                              Click here to take the test
                            </p>
                          </div>

                          <button className="text-gray-600 hover:text-gray-800 transition ml-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-5 w-5 sm:h-6 sm:w-6"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M9 5l7 7-7 7"
                              />
                            </svg>
                          </button>
                          {!user?.je_courses?.includes(courseId ?? []) &&
                            mainClass.is_lock && (
                              <div className="bg-gray-700 bg-opacity-90 p-2 rounded-full flex items-center justify-center ml-2">
                                <Lock size={16} color="white" />
                              </div>
                            )}
                        </div>
                      </>
                    )}
                  </div>
                </div>
              )}

              {selectedTab === "reviews" && (
                <div className="overflow-y-auto min-h-full space-y-3 py-3 sm:py-4">
                  <h3 className="text-lg font-medium text-emerald-700">
                    Reviews
                  </h3>
                  <div className="space-y-3">
                    {reviews.length > 0 ? (
                      reviews.map((review, index) => (
                        <div
                          key={index}
                          className="bg-black border border-dotted border-gray-800 rounded-lg p-3 shadow-sm"
                        >
                          <div className="mb-2">
                            <p className="font-medium text-gray-100 text-base">
                              {review.name}
                            </p>
                            <div className="flex space-x-2 mt-1">
                              {[1, 2, 3, 4, 5].map((star) => (
                                <FaStar
                                  key={star}
                                  className={`${review.rating >= star
                                    ? "text-yellow-500"
                                    : "text-gray-100"
                                    }`}
                                  size={15}
                                />
                              ))}
                            </div>
                          </div>
                          <p className="text-sm text-gray-100">
                            {review.review}
                          </p>
                        </div>
                      ))
                    ) : (
                      <p className="text-sm text-gray-500">
                        No reviews yet. Be the first to review!
                      </p>
                    )}
                  </div>

                  <div className="border-t border-gray-800 pt-3">
                    <h2 className="text-base font-semibold text-gray-100 mb-3">
                      Submit a Review
                    </h2>
                    <form onSubmit={handleReviewSubmit} className="space-y-3">
                      <textarea
                        value={newReview}
                        onChange={(e) => setNewReview(e.target.value)}
                        rows="3"
                        placeholder="Write your review here..."
                        className="w-full p-3 bg-gray-900 border border-gray-800 rounded-lg text-sm text-gray-200 placeholder-gray-500 focus:outline-none focus:border-emerald-500"
                      />

                      <div className="flex space-x-3 py-2">
                        {[1, 2, 3, 4, 5].map((star) => (
                          <FaStar
                            key={star}
                            className={`cursor-pointer transition-colors ${(hover || rating) >= star
                              ? "text-yellow-500"
                              : "text-gray-100"
                              }`}
                            onClick={() => setRating(star)}
                            onMouseEnter={() => setHover(star)}
                            onMouseLeave={() => setHover(0)}
                            size={20}
                          />
                        ))}
                      </div>

                      <button
                        type="submit"
                        className="w-full py-2.5 bg-blue-500 text-white rounded-lg font-medium hover:bg-blue-600 focus:outline-none"
                      >
                        Submit Review
                      </button>
                    </form>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {showTopics && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 animate-fadeIn">
          <div className="bg-black rounded-xl p-6 max-w-md w-[90%] sm:w-[400px] mx-4 transform transition-all duration-300 animate-scaleIn shadow-2xl shadow-emerald-900/20 border-2 border-emerald-700/30">
            <div className="flex justify-between items-center mb-5">
              <h2 className="text-base sm:text-base font-semibold text-white">
                Practice Topics
              </h2>
              <button
                onClick={() => setShowTopics(false)}
                className="p-2 rounded-lg hover:bg-gray-800/50 text-gray-400 hover:text-emerald-700 transition-all duration-200 group"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 group-hover:rotate-90 transition-transform duration-200"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
            <div className="space-y-3 max-h-[60vh] overflow-y-auto custom-scrollbar pr-1">
              {topics.map((topic, index) => (
                <div
                  key={index}
                  className="group flex items-center justify-between p-3.5 bg-gray-900/30 rounded-xl transition-all duration-300 relative overflow-hidden hover:bg-gray-800/30 border border-emerald-700/20 hover:border-emerald-500/40 hover:shadow-[0_0_15px_rgba(16,185,129,0.2)] hover:scale-[1.02]"
                >
                  <div className="absolute inset-0 border border-transparent group-hover:border-emerald-700/20 transition-all duration-300 rounded-xl"></div>
                  <div className="flex items-center gap-3 relative z-10">
                    <div className="p-2 bg-emerald-700/10 rounded-lg group-hover:bg-emerald-700/20 transition-all duration-300">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4 text-emerald-700 group-hover:text-emerald-500 transition-colors duration-300"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                    </div>
                    <h3 className="text-gray-100 text-sm sm:text-sm font-medium group-hover:text-emerald-400 transition-colors duration-300">{`Practice-${index + 1
                      }`}</h3>
                  </div>
                  {topic ? (
                    <a
                      href={topic}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="ml-3 px-3.5 py-2 bg-emerald-700 text-white text-xs rounded-lg hover:bg-emerald-800 transition-all duration-200 transform hover:scale-105 active:scale-95 whitespace-nowrap shadow-lg shadow-emerald-900/30 relative z-10 flex items-center gap-1.5 group/btn hover:shadow-[0_0_15px_rgba(16,185,129,0.3)]"
                    >
                      <span>Start</span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-3.5 w-3.5 group-hover/btn:translate-x-0.5 transition-transform"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M14 5l7 7m0 0l-7 7m7-7H3"
                        />
                      </svg>
                    </a>
                  ) : (
                    <p className="text-gray-100 text-sm sm:text-sm font-medium group-hover:text-emerald-400 transition-colors duration-300">
                      Currently unavailable
                    </p>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VideoPage;